import { render, staticRenderFns } from "./Storewide_discount.vue?vue&type=template&id=136fb964&scoped=true&"
import script from "./Storewide_discount.vue?vue&type=script&lang=js&"
export * from "./Storewide_discount.vue?vue&type=script&lang=js&"
import style0 from "./Storewide_discount.vue?vue&type=style&index=0&id=136fb964&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "136fb964",
  null
  
)

export default component.exports